<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box new_game_popup modal_cont" id="">
        <img :src="closeIconSrc" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_resume_game_welcome_back }} {{ userDetails.username }}!</h1>
        <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
        <p>{{ getTranslations.home_modals_game_in_progress_wait }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'resume-game',
  mixins: [SkinMixin],
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResumeGame.vue